import React, { useState, useEffect } from "react";
import { Col, Container, Form, FormGroup, Label, Input } from "reactstrap";
import CustomInput from "./CustomInput";
import { Eye, EyeOff, GoogleLogo, Mail } from "assets";
import { useNavigate, useSearchParams } from "react-router-dom";
import CustomButton from "components/CustomButton";
import { setCookie } from "services/cookies";
import { API_POST_MAMBOO } from "services";
import useLoginStore from "hooks/useLoginStore";
import { resolvePhotoUrl } from "utils/photo";

const BASE_URL = process.env.REACT_APP_API_URL_SERVER;

const Login = () => {
	const [isPasswordShow, setIsPasswordShow] = useState(false);
	const [loginForm, setLoginForm] = useState({ email: "", password: "" });
	const [loginError, setLoginError] = useState("");
	const { setProfile, fetchServerProfile } = useLoginStore();

	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	// Handle Google OAuth callback
	useEffect(() => {
		const googleToken = searchParams.get("google_token");
		const googleError = searchParams.get("google_error");

		if (googleError) {
			setLoginError(decodeURIComponent(googleError));
			return;
		}

		if (googleToken) {
			// Set token cookie first, then fetch profile
			setCookie("auth_token", googleToken);

			fetchServerProfile().then((profileData) => {
				if (!profileData) {
					setLoginError("Gagal mengambil data profil. Silakan coba lagi.");
					return;
				}

				setCookie("profile", profileData.name);
				setCookie("publisher", profileData.role_code);
				setCookie(
					"photo_profile",
					resolvePhotoUrl(profileData.profile_photo || profileData.photo_profile),
				);
				setCookie("ip_base_number", profileData.ip_base_number);
				setProfile(profileData);
				navigate("/", { replace: true });
			});
		}
	}, [searchParams, navigate, setProfile, fetchServerProfile]);

	const onChange = (e) => {
		const { name, value } = e.target;
		setLoginError("");
		setLoginForm({ ...loginForm, [name]: value });
	};

	const handleRegister = () => {
		navigate("/auth/register");
	};

	const passwordIconAction = () => {
		setIsPasswordShow(!isPasswordShow);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		API_POST_MAMBOO.actions
			.doSignIn(loginForm)
			.then(async (data) => {
				setProfile(data.profile);
				// Ambil peran langsung dari server; App tidak ter-mount ulang setelah login.
				await fetchServerProfile();
				navigate("/");
			})
			.catch((err) => {
				if (err.response?.status === 400) {
					setLoginError("Either email or password is wrong!");
				} else {
					setLoginError("Something is wrong with the server. Try again later");
				}
			});
	};

	const handleGoogleLogin = (e) => {
		e.preventDefault();
		window.location.href = `${BASE_URL}/api/auth/google`;
	};

	return (
		<Container>
			<div className="text-wrapper">
				<h3>Selamat Datang Kembali 👋</h3>
				<h5>
					LOKA Publishing pastikan karya cipta dikelola dengan baik. Bantu nilai ekonomi dari karya ciptamu dengan transparan.
				</h5>
			</div>
			<Col>
				<Form className="auth-form" onSubmit={handleSubmit}>
					<FormGroup className="custom-form-group">
						<CustomInput
							label="Email"
							name="email"
							type="text"
							placeholder="Email address"
							onChange={onChange}
							value={loginForm.email}
							Icon={Mail}
							iconPosition="left"
						/>
					</FormGroup>
					<FormGroup className="custom-form-group">
						<CustomInput
							label="Password"
							name="password"
							onChange={onChange}
							error={loginError}
							value={loginForm.password}
							type={`${isPasswordShow ? "text" : "password"}`}
							secondLabel="Lupa Password ?"
							secondLabelStyle={{ color: 'var(--brand)', cursor: "pointer" }}
							placeholder="Password"
							Icon={isPasswordShow ? Eye : EyeOff}
							iconAction={passwordIconAction}
							iconPosition="right"
						/>
					</FormGroup>
					<FormGroup check inline>
						<Input type="checkbox" />
						<Label check>Remember me</Label>
					</FormGroup>
					<CustomButton label="Sign In" color="primary-btn" />
					<div className="line-separator">
						<div className="line"></div>
						<div className="separator-text">Or</div>
						<div className="line"></div>
					</div>
					<CustomButton
						label="Continue with Google"
						color="white-btn"
						iconPosition="left"
						LabelIcon={GoogleLogo}
						onClick={handleGoogleLogin}
					/>
				</Form>
			</Col>
			<div className="bottom-text">
				<span>Belum Punya Akun? </span>
				<span className="action-text" onClick={handleRegister}>
					Buat akun gratis
				</span>
			</div>
		</Container>
	);
};

export default Login;
